import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '../pages/home.vue'
import html from '../pages/right/html.vue'
import css from '../pages/right/css.vue'
import font from '../pages/right/font.vue'
import cut from '../pages/right/cut.vue'
import framework from '../pages/right/framework.vue'
import plugins from '../pages/right/plugins.vue'
import vue from '../pages/right/vue.vue'
import js from '../pages/right/js.vue'
import other from '../pages/right/other.vue'
import project from '../pages/right/project.vue'

Vue.use(VueRouter)

const routes = [
    {
        redirect: '/home',
        path: '/',
    },{
        path: '/home',
        name: 'home',
        component: home,
        children: [
            {
                path: 'html',
                component: html
            },{
                path: 'css',
                component: css
            },{
                path: 'font',
                component: font
            },{
                path: 'cut',
                component: cut
            },{
                path: 'framework',
                component: framework
            },{
                path: 'plugins',
                component: plugins
            },{
                path: 'vue',
                component: vue
            },{
                path: 'js',
                component: js
            },{
                path: 'other',
                component: other
            },{
                path: 'project',
                component: project
            }
        ]
    }
]

const router = new VueRouter({
    routes
})

router.beforeEach((to, from, next) => {
    if (from && to.path !== from.path) {
        document.getElementById('app').scrollTop = 0
    }
    next()
})

export default router